import React from "react";
import { format } from "date-fns";
import MatUITable from "../../../components/MatUITable/MatUITable";
import Heading from "../../../components/Heading/Heading";
import axios from "../../../utils/Axios/axiosProxy";

function UserMessages({ ...props }) {
  const createTableData = (messages) => {
    let rowData = [];
    for (let key in messages.threads) {
      let msgArr = messages.threads[key].messages;
      let length = msgArr.length;
      if (length > 0) {
        let seen =
          msgArr[length - 1].sender === "user" ? msgArr[length - 1].seen : true;
        rowData.push({
          threadID: messages.threads[key]._id,
          threadIDDisplay: (
            <span className={!seen ? "Bold" : ""}>
              {messages.threads[key]._id}
            </span>
          ),
          sent: (
            <span className={!seen ? "Bold" : ""}>
              {format(new Date(msgArr[length - 1].date), "yyyy-MM-dd")}
            </span>
          ),
          message: (
            <span className={!seen ? "Bold" : ""}>{`${msgArr[
              length - 1
            ].message.substring(0, 20)} ...`}</span>
          ),
          dialogData: messages.threads[key],
          seen: seen,
          userID: messages.userID,
        });
      } else {
        rowData.push({
          threadID: messages.threads[key]._id,
          threadIDDisplay: messages.threads[key]._id,
          sent: format(new Date(), "yyyy-MM-dd"),
          message: "No messages yet",
          dialogData: messages.threads[key],
          userID: messages.userID,
        });
      }
    }
    return rowData;
  };

  const startNewThread = (userID) => {
    let data = { userID: userID };
    axios
      .patch("/api/communication/thread", data, {
        headers: {
          /* Authorization: `Bearer ${JWT}`, */
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("NEW THREAD RESPONSE: ", response.statusText);
        props.updateMessages(response.data.messages);
      })
      .catch((error) => {
        console.log("NEW THREAD ERROR: ", error);
      })
      .catch((error) => console.log("NEW THREAD CLIENT ERROR", error));
  };
  return (
    <div>
      <Heading
        title="Messages"
        button
        titleB="New Message"
        onClick={() => startNewThread(props.messages.userID)}
        className="ToreaBay Medium"
      />
      <MatUITable
        updateMessages={props.updateMessages}
        paging={true}
        page="adminmessage"
        pageSize={5}
        columns={[
          {
            title: "ThreadID",
            field: "threadIDDisplay",
            align: "left",
          },
          {
            title: "Sent",
            field: "sent",
            align: "left",
            defaultSort: "desc",
          },
          {
            title: "Message",
            field: "message",
            align: "left",
          },
        ]}
        data={createTableData(props.messages)}
      />
    </div>
  );
}

export default UserMessages;
